module.exports = __webpack_public_path__ + "static/img/6.4c5dd5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/6.png
// module id = 6W7y
// module chunks = 0